<template>
    <div>
        <h6>
            OSHA Violations:
            <template v-if="editMode">
                <button type="button" class="btn btn-sm btn-info" v-on:click="newOshaCitation()" title="Add OSHA Violations"><i class="fa fa-plus-circle"></i></button><br>
                <small>Enter any OSHA Violation within last {{ this.$store.state.user.sub_years_required }} years</small>
            </template>
        </h6>

        <osha-citation-modal ref="subOshaCitationModal" :subcontractorId="subcontractorId" v-if="editMode" />

        <b-table bordered striped hover small responsive :items="citationOptions" :fields="fields">
            <template v-slot:cell(osha_citation_id)="data">
                <button type="button" class="btn btn-sm btn-link" @click="editOshaCitation(data.item)" title="Edit Violation"><i class="fa fa-edit"></i></button>
                <button type="button" class="btn btn-sm btn-link text-danger" @click="deleteOshaCitation(data.item)" title="Delete Violation"><i class="fa fa-trash"></i></button>
            </template>
            <template v-slot:cell(citation_date)="data">
                 {{ data.value | moment("MM/DD/YYYY") }}
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        props: {

            editMode: {
                type: Boolean,
                default: false,
            },

            subcontractorId: {
                type: Number,
                required: true,
            },

            citations: {
                type: Array,
                default: null,
            },

        },

        data: function() {
            return {
                citationOptions: this.citations ? this.citations : this.$store.state.subcontractor.citations,
            }
        },

        computed: {
            fields(){
                //Check for edit mode
                if(this.editMode)
                {
                    return [
                        {key: 'osha_citation_id', label: 'Edit'},
                        {key: 'citation_type', label: 'Type'},
                        {key: 'citation_date', label: 'Date'},
                        {key: 'citation_details', label: 'Details'},
                    ];
                }

                return [
                    {key: 'citation_type', label: 'Type'},
                    {key: 'citation_date', label: 'Date'},
                    {key: 'citation_details', label: 'Details'},
                ];
            },
        },

        methods: {

            newOshaCitation(){
                //Set the prop
                this.$refs.subOshaCitationModal.setModel({});

                //Activate the modal
                this.$refs.subOshaCitationModal.showModal();
            },

            editOshaCitation(citation){
                //Set the prop
                this.$refs.subOshaCitationModal.setModel(citation);

                //Activate the modal
                this.$refs.subOshaCitationModal.showModal();
            },

            deleteOshaCitation(citation){
                //Check for confirm
                if(!confirm('Are you sure you want to delete this violation? '))
                {
                    return;
                }

                //Send it
                this.$http
                    .post('/subcontractors/osha-citation/delete/' + citation.osha_citation_id)
                    .then(response => {
                        //Alert
                        this.$toastr.success('Violation Deleted');

                        //Delete the bid
                        this.$store.commit('deleteCitation', citation);

                    });
            },
        },

        mounted() {

        }
    }
</script>